import UI from './utils/UI'
import { mq } from './config'
import bus from './bus'

UI({
  component: '.js-tagNav',
  list: '.js-tagNav-list',
  listLayout: '.js-tagNav-listLayout',
  select: '.js-tagNav-select',
  hide: '.js-tagNav-listHide',
  show: '.js-tagNav-listShow'
}, ({ component, list, select, listLayout, hide, show }) => {
  toggleTabIndex()
  bus.on('window-resize', toggleTabIndex)
  select.addEventListener('change', handleSelectChange, false)
  show.addEventListener('click', showClickHandler, false)
  hide.addEventListener('click', hideClickHandler, false)

  function handleSelectChange (evt) {
    const to = evt.target.value
    if (to !== window.location.href) {
      window.location = to
    }
  }

  function toggleTabIndex () {
    select.setAttribute('tabIndex', mq.md.matches ? -1 : 0)
    Array.from(listLayout.querySelectorAll('a, button')).forEach(a => a.setAttribute('tabIndex', mq.md.matches ? 0 : -1))
  }

  function showClickHandler (evt) {
    evt.preventDefault()
    listLayout.classList.add('is-open')
  }

  function hideClickHandler(evt) {
    evt.preventDefault()
    window.location = component.getAttribute('data-base-url')
  }
})
